<template>
    <div class="min-h-screen flex items-center justify-center bg-gray-50 px-4 sm:px-6 py-8">
        <div class="max-w-md w-full bg-white border border-gray-200 rounded-2xl shadow-sm p-6 sm:p-10 text-center">
            <img src="../assets/logo.png" class="w-40 mx-auto mb-6" alt="SIRIMMATRIX" />

            <div v-if="loading" class="text-sm text-gray-400 py-8">
                Confirmando seu email...
            </div>

            <div v-else-if="error" class="py-2">
                <h1 class="text-[22px] sm:text-[24px] font-semibold text-[#101414] mb-3">{{ errorTitle }}</h1>
                <p class="text-[15px] text-[#333A44] leading-[1.6] mb-6">{{ errorMessage }}</p>

                <div v-if="showResend">
                    <input
                        type="email"
                        v-model="resendEmail"
                        placeholder="seuemail@email.com"
                        class="w-full h-[52px] px-4 mb-3 text-base bg-white border border-[#D9D9D9] rounded-xl text-[#171717] placeholder:text-gray-400 focus:outline-none focus:border-cyan-600 focus:ring-2 focus:ring-cyan-600/15 transition-colors"
                    />
                    <button
                        type="button"
                        @click="resend"
                        :disabled="resending || !resendEmail"
                        class="w-full h-[52px] rounded-xl bg-cyan-600 text-white font-medium text-base hover:bg-cyan-700 disabled:opacity-60 transition-colors"
                    >
                        {{ resending ? 'Enviando...' : 'Reenviar link de confirmação' }}
                    </button>
                    <p v-if="resendMessage" class="text-emerald-600 text-sm mt-3">{{ resendMessage }}</p>
                </div>

                <router-link :to="{ name: 'login' }" class="block mt-6 text-[14px] font-medium text-cyan-600 hover:underline">Voltar ao login</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import AuthService from '../services/AuthService';

export default {
    name: 'ConfirmEmail',
    setup() {
        const route = useRoute();
        const router = useRouter();
        const token = route.params.token;

        const loading = ref(true);
        const error = ref(false);
        const errorTitle = ref('');
        const errorMessage = ref('');
        const showResend = ref(false);
        const resendEmail = ref('');
        const resending = ref(false);
        const resendMessage = ref('');

        onMounted(async () => {
            try {
                const { data: { data } } = await AuthService.confirmEmail(token);
                AuthService.storeLocalData({ ...data });
                router.push({ name: 'home' });
            } catch (err) {
                const code = err?.response?.data?.error;
                error.value = true;
                if (code === 'token_expired') {
                    errorTitle.value = 'Link expirado';
                    errorMessage.value = 'Este link de confirmação expirou. Digite seu email para receber um novo link.';
                    showResend.value = true;
                } else {
                    errorTitle.value = 'Link inválido';
                    errorMessage.value = 'Não encontramos esse link de confirmação. Ele já pode ter sido usado ou é inválido.';
                    showResend.value = true;
                }
            } finally {
                loading.value = false;
            }
        });

        async function resend() {
            resending.value = true;
            resendMessage.value = '';
            try {
                await AuthService.resendConfirmation(resendEmail.value.trim().toLowerCase());
                resendMessage.value = 'Se esse email estiver cadastrado e pendente de confirmação, um novo link foi enviado.';
            } catch {
                resendMessage.value = 'Erro ao reenviar. Tente novamente em instantes.';
            } finally {
                resending.value = false;
            }
        }

        return { loading, error, errorTitle, errorMessage, showResend, resendEmail, resending, resendMessage, resend };
    }
}
</script>
